import React, { useState, useEffect } from 'react';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Dialog from '@visa/vds/dialog';
import DialogCardBody from '@visa/vds/dialog-card-body';
import DialogCardFooter from '@visa/vds/dialog-card-footer';
import DialogCardHead from '@visa/vds/dialog-card-head';
import DialogCardHeadTitle from '@visa/vds/dialog-card-head-title';
import FormControl from '@visa/vds/form-control';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import MCSSpace from '../../../components/MCSSpace';
import MCSOverlayLoading from '../../../components/MCSOverlayLoading';
import { DateHelper } from '../../../_helpers/DateHelper';

const UserAnnouncementDialog = (props) => {

    const [loading, setLoading] = useState(false);

    function displayAnnouncement() {
        return { __html: props.announcement && props.announcement.announcementDetails }
    }  

    return (
        <>
            {loading &&
                <MCSOverlayLoading />}
            <Dialog
                aria-describedby="Announcement Details"
                onExit={() => { }}
                open={props.openAnnouncementDialog}
                titleId="dialog-manage-announcement"
            >
                <DialogCardHead>
                    <DialogCardHeadTitle id="dialog-title-manage-file">{props.announcement && props.announcement.announcementName}</DialogCardHeadTitle>
                    <p>{(props.announcement && props.announcement.startDate) ? DateHelper.ToLocaleDateString(props.announcement && props.announcement.startDate) : ''}</p>
                </DialogCardHead>

                <DialogCardBody id="dialog-description-manage-file-field">
                    <Grid>                
                        <MCSSpace />
                        <Row noGutter key={1}>
                            <Col noTopGutter noGutter lg={12}>
                                <FormControl>
                                    <div style={{fontFamily:"OpenSans,sans-serif;",fontColor:"black"}} dangerouslySetInnerHTML={displayAnnouncement()} />
                                </FormControl>
                            </Col>
                        </Row>
                        <MCSSpace />
                        <MCSSpace />
                    </Grid>
                <MCSSpace />
                </DialogCardBody>
                <DialogCardFooter>
                    <ButtonGroup direction="right">
                        <ButtonText
                            colorScheme="secondary"
                            onClick={() => {
                                props.setSelectedAnnouncement(null);
                            }}
                        >
                            Close
                        </ButtonText>
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog>
        </>
    )
}

export default UserAnnouncementDialog